module.exports = __webpack_public_path__ + "static/img/200246.9f91deaa.png";